import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CountBarComponent } from "./count-bar/count-bar.component";
import { MaterialModule } from "../../material-module";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgxMatMomentModule } from "@angular-material-components/moment-adapter";
import { NgxMaskModule } from "ngx-mask";
import { NgxMatIntlTelInputModule } from "ngx-mat-intl-tel-input";
import { SkeletonLoaderComponent } from "./skeleton-loader/skeleton-loader.component";
import { ImageDialogComponent } from "./image-upload/image-dialog/image-dialog.component";
import { RejectQuoteComponent } from "./reject-quote/reject-quote.component";
import { FileUploaderPopupComponent } from "./file-uploader-popup/file-uploader-popup.component";
import { EmptyRecordModule } from "./empty-record/empty-record.module";
import { CustomDirectiveModule } from "../directive/custom-directive.module";

@NgModule({
  declarations: [
    CountBarComponent,
    SkeletonLoaderComponent,
    ImageDialogComponent,
    RejectQuoteComponent,
    FileUploaderPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    NgxSkeletonLoaderModule,
    FlexLayoutModule,
    MatBottomSheetModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    NgxMatMomentModule,
    NgxSkeletonLoaderModule,
    NgxMaskModule,
    NgxMatIntlTelInputModule,
    EmptyRecordModule,
    CustomDirectiveModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    EmptyRecordModule,

    NgxMaskModule,
    NgxMatSelectSearchModule,
    NgxMatMomentModule,
    FlexLayoutModule,

    CountBarComponent,
    SkeletonLoaderComponent,
    RejectQuoteComponent,
    FileUploaderPopupComponent,

    CustomDirectiveModule
  ]
})
export class SharedComponentModule {}
